import { useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, CardHeader, CardBody, CardFooter, CardText, Button } from 'reactstrap'
import './MessageCard.css'

export default function MessageCard(props) {
  const { title, message, buttonText, clickUrl } = props
  console.log('MessageCard rendered', props)

  const buttonRef = useRef(null)
  useEffect(() => {
    buttonRef.current.focus()
  }, [])
  const navigate = useNavigate()

  function buttonClicked() {
    if (clickUrl) {
      navigate(clickUrl)
    } else {
      navigate(-1)  // go back 1 page
    }
  }

  return (
    <Card className="message-card">
      <CardHeader tag="h4">{title}</CardHeader>
      <CardBody>
        <CardText>{message}</CardText>
      </CardBody>
      <CardFooter>
        <Button innerRef={buttonRef} color="primary" className="message-card-button" data-cy="message-card-button" onClick={buttonClicked}>{buttonText ? buttonText : 'Ok'}</Button>
      </CardFooter>
    </Card>
  )
}